<template>
  <div class="top-edit-bar mb-1" v-if="selected_items && selected_items.length > 0">
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <div class="top-edit-bar-icon fas fa-times" v-bind="attrs" v-on="on" @click="clearSelection()"></div>
      </template>
      <span>Clear Selection</span>
    </v-tooltip>
    <div class="top-edit-bar-text">{{ selected_items.length }} Selected</div>

    <v-hover v-if="canAddTask" v-slot="{ hover }">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon @click="addLinkToTask()" :color="hover ? 'orange' : 'white'" :disabled="!canAddTask">
            <v-icon>mdi-calendar-plus</v-icon>
          </v-btn>
        </template>
        <span>Add to Task</span>
      </v-tooltip>
    </v-hover>

    <v-hover v-if="canOpen" v-slot="{ hover }">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon @click="openSelected()" :color="hover ? 'orange' : 'white'" :disabled="!canOpen">
            <v-icon>mdi-eye</v-icon>
          </v-btn>
        </template>
        <span>View Selected Items</span>
      </v-tooltip>
    </v-hover>

    <v-hover v-if="canIsolate" v-slot="{ hover }">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" small icon @click="markAsIsolated()" :color="hover ? 'orange' : 'white'" :disabled="!canIsolate">
            <v-icon small>fa-solid fa-arrow-up-right-from-square</v-icon>
          </v-btn>
        </template>
        <span>Isolate in 3D</span>
      </v-tooltip>
    </v-hover>

    <v-hover v-if="canCrop" v-slot="{ hover }">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon @click="$emit('crop-selection')" @contextmenu.prevent="$emit('crop-selection-right')" :color="hover ? 'orange' : 'white'">
            <v-icon>mdi-crop</v-icon>
          </v-btn>
        </template>
        <span>Left-click: Crop 3D | Right-click: Open Nearby Scans</span>
      </v-tooltip>
    </v-hover>

    <v-hover v-slot="{ hover }">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            @click="deleteSelectedTags()"
            :color="hover ? 'orange' : 'white'"
            :disabled="loading"
            :loading="loading">
            <v-icon>mdi-trash-can</v-icon>
          </v-btn>
        </template>
        <span>Delete Selected Items</span>
      </v-tooltip>
    </v-hover>
  </div>
</template>

<script>
  import { ForgeBaseTag, ForgeEquipment } from '@/scripts/js/forgeModels';

  export default {
    name: 'SelectionInfo',
    props: ['selected_items', 'canOpen', 'loading'],
    emits: ['delete-selection', 'clear-selection', 'crop-selection', 'crop-selection-right'],
    methods: {
      clearSelection() {
        this.$emit('clear-selection');
        // this.selected_items.forEach(o => o.isSelected = false);
        // this.selected_items.splice(0, this.selected_items.length);
      },
      deleteSelectedTags() {
        this.$emit('delete-selection');
      },
      markAsIsolated() {
        this.$emit('mark-isolated');
      },
      openSelected() {
        this.$emit('open');
      },
      addLinkToTask() {
        this.mainApp.$refs.addToPlan?.open(this.selected_items);
      },
    },
    computed: {
      mainApp() {
        return this.$store.state.mainApp;
      },
      canIsolate() {
        return this.selected_items
          .filter((o) => o instanceof ForgeEquipment)
          .some((o) => !o.isIsolated);
      },
      canAddTask() {
        return this.selected_items.every((o) => o instanceof ForgeBaseTag);
      },
      canCrop() {
        if (!this.selected_items.some((o) => o.point)) return false;
        return true;
      },
    },
  };
</script>

<style>
  .top-edit-bar {
    width: -webkit-fill-available;
    background-color: #545454;
    border-radius: 1px;
    display: flex;
    z-index: 2;
    padding: 4px;
    align-items: center;
    border-radius: 4px;
    /* animation-name: showTopBarAnim;
    animation-duration: 0.5s; */
    margin-top: 5px;
  }

  @keyframes showTopBarAnim {
    0% {
      height: 0;
      padding: 0;
      display: none;
    }

    100% {
      height: 22px;
      padding: 6px;
      display: flex;
    }
  }

  .top-edit-bar-icon {
    font-size: 16px;
    color: white;
    margin: 4px;
    cursor: pointer;
  }

  .top-edit-bar-icon:hover {
    color: orange;
  }

  .top-edit-bar-text {
    font-size: 12px;
    color: white;
    flex-grow: 1;
  }
</style>
